<template>
  <div class="section-title">
    <div class="section-title-icon">
      <router-link :to="url">
        <button><i class="icofont-reply"></i> <span>Voltar</span></button>
      </router-link>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <ModalInfo />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalAjuda from '@/components/ModalAjuda'
import ModalInfo from './ModalInfo'

export default {
  name: 'SectionTitle',
  components: {
    ModalAjuda,
    ModalInfo,
  },
  computed: mapState(['modal_ajuda']),
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {},
    },
    linkvideoajuda: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showModalAjuda: true,
    }
  },
  methods: {
    exibirModalAjuda() {
      this.showModalAjuda = true
      this.$store.commit('setModalAjuda', true)
    },
    closeModalAjuda() {
      this.showModalAjuda = false
    },
    naoExibirAjuda() {
      this.$store.commit('setModalAjuda', false)
    },
  },
}
</script>

<style></style>
